import { useContainer } from '../../useContainer';
import { ACSApi, ToastStateHandler } from '../../../api';
import { useTranslation } from '../../useTranslation';
import { dispatch } from '../../../store';
import { invalidateProjectsCache, invalidateSingleProjectCache, updateCachedProject } from '../../../store/slices/projects.slice';

const useHttpUnarchiveProject = () => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const toastHandler: ToastStateHandler = useContainer(ToastStateHandler);
    const { t } = useTranslation('newNotifications');

    const exec = (projectId: string, onSuccess?: () => void, onError?: () => void) => {
        const { exec: apiExec, abort } = acsApi.unarchiveProject({
            params: { id: projectId },
            onSuccess: res => {
                dispatch(updateCachedProject(res.body));
                dispatch(invalidateProjectsCache());
                dispatch(invalidateSingleProjectCache(projectId));
                toastHandler.push('success', t('projects.projectUpdateTitle'), 'Project restored successfully.');
                onSuccess?.();
            },
            onError: () => {
                toastHandler.push('error', t('projects.projectUpdateTitle'), 'Failed to restore project.');
                onError?.();
            },
        });

        apiExec();
        return abort;
    };

    return { exec };
};

export default useHttpUnarchiveProject;
